import { gql as apolloGql } from '@apollo/client'
import { customAlphabet } from 'nanoid'

import client from '..'
import { nanoIdCharacters } from '../../constants'

// Aliases can't be used in type gen or hooks
// Must mutate directly on the client
export const addUsersToAccountsBulk = async ({
  users,
  accountIDs,
  permissionLevelList,
}: {
  users: string[]
  accountIDs: string[]
  permissionLevelList: PermissionLevel[]
}) => {
  let addMutation = ``
  const alias = customAlphabet(nanoIdCharacters, 10)

  users.forEach((user) => {
    addMutation += `
      ${alias()}:addUserToAccountBulk(
        accountIDList: ${JSON.stringify(accountIDs)},
        email: "${user}",
        permissionLevelList: ${JSON.stringify(permissionLevelList)},
      ) {
          userID
          email
          inviteOpen
          userAccountProfiles {
            userEmail
            accountID
            accountName
            userPermission
            companyID
            inviteOpen
          }
      }
    `
  })

  return client.mutate({
    mutation: apolloGql`
        mutation AddUsersToAccountsBulk {
          userAccountSettings {
            ${addMutation}
          }
        }
      `,
  })
}
